import { Component, Input } from '@angular/core';
import { CellDataType } from '../../interfaces/data-import/cell-data-type';
import { IImportEntry } from '../../interfaces/data-import/import-entry';
import { IImportEntryCell } from '../../interfaces/data-import/import-entry-cell';
import moment from 'moment';

@Component({
  selector: 'import-result',
  templateUrl: './import-result.component.html',
  styleUrls: ['./import-result.component.css'],
  //providers: [ConfirmationService, EmployeeService]
})
export class ImportResultComponent {
  columns: { header: string; value: any }[] = [];
  validEntriesWrappers: any[] = [];
  dialogIsVisible = false;
  cellsForDetails: IImportEntryCell[] = [];

  private _validEntries: IImportEntry[];

  @Input()
  set validEntries(value: IImportEntry[]) {
    console.log(value);
    this._validEntries = value || [];
    this.refreshColumns(value);
    this.validEntriesWrappers = value ? value.map(this.createWrapper) : [];
  }

  get validEntries() {
    return this._validEntries;
  }

  showDetails(entry: IImportEntry): void {
    this.cellsForDetails = entry.cells.filter((c) => c.errorMessage);
    this.dialogIsVisible = true;
  }

  onDetailsHide() {
    this.cellsForDetails = [];
  }

  private createWrapper(entry: IImportEntry): any {
    let wrapper = { entry: entry, lineNumber: entry.lineNumber, error: entry.errorMessage };
    for (let i = 0; i < entry.cells.length; i++) {
      let cell = entry.cells[i];

      if (cell.errorMessage) {
        wrapper[cell.targetFieldName] = cell.value;
      } else {
        switch (cell.type) {
          case CellDataType.Date:
            wrapper[cell.targetFieldName] = cell.value
              ? moment(cell.value).format('DD/MM/YYYY hh:mm')
              : cell.value;
            break;
          default:
            wrapper[cell.targetFieldName] = cell.value;
        }
      }
    }
    return wrapper;
  }

  private refreshColumns(entries: IImportEntry[]): void {
    let cols = [];

    if (entries && entries.length) {
      let entry: IImportEntry = entries[0];

      for (let i = 0; i < entry.cells.length; i++) {
        let cell = entry.cells[i];

        let col = { header: cell.targetFieldName, value: cell.value };
        cols[cell.orderNumber - 1] = col;
      }
    }

    this.columns = cols;
  }
}
